'use client';

import type { UseAccordionDropdownProps } from './hooks/use-accordion-dropdown';
import { AccordionDropdownProvider } from './contexts/accordion-dropdown-context';

import { DropdownTrigger } from './dropdown-trigger';

export const AccordionDropdown = (props: UseAccordionDropdownProps) => {
	return (
		<AccordionDropdownProvider {...props}>
			<DropdownTrigger />
		</AccordionDropdownProvider>
	);
};